import { useCheckoutForms } from "@shared/modules/checkout/hooks/useCheckoutForms";
import Flex from "@ui-kit/layout/Flex/Flex.web";
import Text from "@ui-kit/typography/Text/Text.web";
import { useTranslation } from "@shared/utils/internationalization";
import CheckoutBaseLayoutWithCart from "@app-contexts/public/shared/checkout/templates/CheckoutBaseLayoutWithCart/CheckoutBaseLayoutWithCart.web";
import { ContinueButton } from "@app-contexts/public/shared/checkout/components/ContinueButton/ContinueButton.web";
import CheckoutSummary from "@app-contexts/public/shared/checkout/components/CheckoutSummary/CheckoutSummary.web";
import { CustomQuestionsForm } from "./CustomQuestionsForm.web";

export default function CustomQuestions({
  checkoutForms,
  onValid,
  onInvalid,
  hideContinueButton,
}: {
  checkoutForms: ReturnType<typeof useCheckoutForms>;
  onValid?: () => void;
  onInvalid?: () => void;
  hideContinueButton?: boolean;
}): JSX.Element {
  const { t } = useTranslation("common");
  return (
    <CheckoutBaseLayoutWithCart
      rightColumn={
        <CheckoutSummary
          callToActionButton={hideContinueButton ? null : <ContinueButton />}
        />
      }
    >
      <Flex
        p={{ base: "lg", sm: "32px 40px" }}
        gap="md"
        direction="column"
        bg="bg"
      >
        <Text
          fontSize="xl"
          fontWeight="bold"
          data-testid="questions-page-heading"
        >
          {t("Just a few questions")}
        </Text>
        <Flex direction="column" gap="md">
          <CustomQuestionsForm
            checkoutForms={checkoutForms}
            onValid={onValid}
            onInvalid={onInvalid}
          />
        </Flex>
      </Flex>
    </CheckoutBaseLayoutWithCart>
  );
}
